import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { ExtractionSchedulingRecipesRoute } from '../../routing'

export  class ExtractionSchedulingRecipesPage extends Component {
    render() {
        return (
            <Fragment>
            <Breadcrumbs />
            <ExtractionSchedulingRecipesRoute />
          </Fragment>
        )
    }
}
